import {
    useAuth,
} from "../../context/AuthContext";

function DashboardHeader() {

    const {
        userProfile,
    } = useAuth();

    const userName =

        userProfile?.name ||

        userProfile?.email?.split("@")[0] ||

        "Player";

    return (

        <div style={styles.header}>

            <h1 style={styles.title}>

                Welcome back,
                {" "}

                <span style={styles.userName}>
                    {userName}!
                </span>

            </h1>

            <p style={styles.subtitle}>

                Here’s a quick overview of your bookings and activity.

            </p>

        </div>
    );
}

const styles = {

    header: {

        marginBottom: "32px",
    },

    title: {

        color: "#fff",

        fontSize: "38px",

        fontWeight: "800",

        margin: 0,

        lineHeight: 1.2,
    },

    userName: {

        background:
            "linear-gradient(90deg, #00ff88, #00d4ff)",

        WebkitBackgroundClip:
            "text",

        WebkitTextFillColor:
            "transparent",

        fontWeight:
            "900",

        textShadow:
            "0 0 18px rgba(0,255,136,0.25)",
    },

    subtitle: {

        color: "#d1d5db",

        fontSize: "15px",

        marginTop: "10px",
    },
};

export default DashboardHeader;